import React from "react";
import { string, bool, func } from "prop-types";

import "./radioButton.m.css";

const RadioButton = ({ title, value, name, isChecked, onClick }) => (
  <label styleName="container">
    <span styleName={isChecked ? "title" : null}>{title}</span>
    <input
      type="radio"
      defaultChecked={isChecked}
      value={value}
      name={name}
      styleName="radio-input"
      onClick={onClick}
    />
    <span styleName="checkmark" />
  </label>
);

RadioButton.defaultProps = {
  isChecked: false,
  name: "radio"
};

RadioButton.propTypes = {
  title: string,
  name: string,
  value: string,
  isChecked: bool,
  onClick: func
};

export default RadioButton;
